<div class="tables-main-container">
  <div class="header">
    <div class="header-content">
      <div class="header-text">
        <h2>{{ 'TABLES.TITLE' | translate }}</h2>
        <p class="subtitle">{{ 'TABLES.HOME' | translate }}</p>
      </div>
      <div class="header-filter">
        <app-notification-filter [notifications]="tables" storageKey="tables_filter_unread">
        </app-notification-filter>
      </div>
    </div>
  </div>
  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="loadTables()">{{ 'GLOBAL.RETRY' | translate }}</button>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <div class="items-grid">
      <div class="item-card" *ngFor="let table of filteredTables" [class.unread]="!table.isRead"
        (click)="onTableClick(table.notificationID)" role="button" tabindex="0"
        (keydown.enter)="onTableClick(table.notificationID)" (keydown.space)="onTableClick(table.notificationID)">

        <div class="card-header">
          <h3 class="item-title">{{ table.title }}</h3>
          <span class="item-date">{{ formatDate(table.created) }}</span>
        </div>

        <div class="card-body">
          <p class="item-preview">{{ getPreviewText(table.body) }}</p>
        </div>

        <div class="card-footer">
          <span class="read-status" [class.unread]="!table.isRead">
            {{ getReadStatusText(table.isRead) | translate }}
          </span>
          <span class="view-details">{{ 'GLOBAL.DETAIL' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="no-items" *ngIf="filteredTables.length === 0">
      <div class="no-items-card">
        <div class="no-items-icon">
          <mat-icon>table_view</mat-icon>
        </div>
        <h3>{{ 'TABLES.NO_TABLES' | translate }}</h3>
        <p>{{ 'TABLES.NO_TABLES_MESSAGE' | translate }}</p>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'TABLES.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>